import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { isContainerItem } from '@bloomreach/spa-sdk';
import { getDisplayName } from '@grandvisionhq/utils';

/**
 * With this HoC, CmsContainers can be hidden by content editors
 * for specific audiences using Br's relevance module.
 * Only works for Bloomreach components of type CONTAINER_ITEM_COMPONENT
 */ function withHidableContent(Component) {
    const displayName = getDisplayName(Component);
    const WithHidableContent = (props)=>{
        const { component , page  } = props || {};
        const preview = page === null || page === void 0 ? void 0 : page.isPreview();
        const hidden = component && isContainerItem(component) ? component.isHidden() : false;
        // A Cms component should always be shown in preview mode
        if (hidden && !preview) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props));
    };
    WithHidableContent.displayName = `withHidableContent(${displayName})`;
    return WithHidableContent;
}

export { withHidableContent };
//# sourceMappingURL=with-hidable-content.js.map
